/*
 * Auf dem Telefon wandern die Konto-Aktion (und ggf. Kaufen) in die Schublade und
 * stehen dort nebeneinander ueber der Suche. Oben bleiben Logo, die
 * Ankaufs-Schaltflaeche und der Warenkorb.
 */
class TeknotextKopfaktionen extends HTMLElement {
  connectedCallback() {
    this.#kontofenster();

    this.beweglich = Array.from(this.querySelectorAll('[data-tk-mobil]'));
    if (this.beweglich.length === 0) return;

    // Die Ausgangsreihenfolge merken, damit sie beim Zurueckwandern wieder steht.
    this.reihenfolge = Array.from(this.children);

    this.rumpf = document.querySelector('[data-tk-schubladen-rumpf]');
    if (!this.rumpf) return;

    this.abfrage = window.matchMedia('(max-width: 619px)');
    this.#ordnen();
    this.abfrage.addEventListener('change', () => this.#ordnen());
  }

  // Shopifys Kontofenster oeffnet an einer festen Hoehe. Sie wird beim Oeffnen auf die
  // Unterkante des Kopfbereichs gesetzt, die sich mit Ankuendigungsleiste und Scrollen aendert.
  #kontofenster() {
    const konto = this.querySelector('.tk-kopf__konto');
    const kopf = this.closest('.tk-kopf');
    if (!konto || !kopf) return;

    const setzen = () => {
      const unterkante = Math.round(kopf.getBoundingClientRect().bottom);
      konto.style.setProperty('--tk-konto-oben', `${unterkante}px`);
    };
    konto.addEventListener('pointerdown', setzen, true);
    konto.addEventListener('keydown', setzen, true);
  }

  // Die Schublade bringt ihre Aktionszeile (mit dem Ankauf) selbst mit; nur ohne sie
  // entsteht eine eigene.
  get #ablage() {
    if (!this.gruppe) {
      this.gruppe = this.rumpf.querySelector('[data-tk-schubladen-aktionen]');
      this.eigeneGruppe = !this.gruppe;
      if (this.eigeneGruppe) {
        this.gruppe = document.createElement('div');
        this.gruppe.className = 'tk-kopf__schubladenaktionen';
      }
    }
    return this.gruppe;
  }

  #ordnen() {
    if (this.abfrage.matches) {
      const ablage = this.#ablage;
      this.beweglich.forEach((element) => ablage.append(element));
      if (this.eigeneGruppe) this.rumpf.prepend(ablage);
    } else {
      this.reihenfolge.forEach((element) => this.append(element));
      if (this.gruppe && this.eigeneGruppe) this.gruppe.remove();
    }
  }
}

if (!customElements.get('teknotext-kopfaktionen')) {
  customElements.define('teknotext-kopfaktionen', TeknotextKopfaktionen);
}
